/*
 * Created by IRIS Interactive
 * User : IRIS Interactive
 */

import BannerComponent from './components/banner.component'
import NavbarComponent from './components/navbar.component'
import ToolsbarComponent from './components/toolsbar.component'
import NestorTriggerComponent from "./components/nestor-trigger.component";

document.addEventListener('DOMContentLoaded', () => {
	//Component
	new NavbarComponent()
	new ToolsbarComponent()
	new BannerComponent()
	new NestorTriggerComponent()

	//Front page only
	if ($('.home').length > 0) {
		import(
			'@scripts/services/home.service' /* webpackChunkName: "scripts/home.service" */
			).then(({default: HomeService}) => {
			new HomeService()
		})
	}

	//Fullscreen template only
	if ($('.fullscreen').length > 0) {
		import(
			'@scripts/services/layout.service' /* webpackChunkName: "scripts/layout.service" */
			).then(({default: LayoutService}) => {
			new LayoutService()
		})
	}
})
